var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg824",
    width: 33.279999,
    height: 30.08,
    viewBox: "0 0 33.279999 30.08",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs828"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer4",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.018918,8.1174866 1.8109428,28.236163 H 31.448904 l -9.45706,-15.359764 m 5.155647,8.476127 -19.7242586,-0.08696",
    stroke: "#cc214f",
    strokeWidth: 4.11788,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path948-5-9",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#203864",
      strokeWidth: 3.62216,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20.659119,4.5318524 c 0,2.5028178 -2.031752,4.5318524 -4.537923,4.5318524 -2.50617,0 -4.537923,-2.0290346 -4.537923,-4.5318524 C 11.583273,2.0290343 13.615026,0 16.121196,0 c 2.506171,0 4.537923,2.0290343 4.537923,4.5318524 z m -5.871797,0 c 0,0.7356698 0.597219,1.3320892 1.333874,1.3320892 0.736657,0 1.333873,-0.5964194 1.333873,-1.3320892 0,-0.7356716 -0.597216,-1.3320896 -1.333873,-1.3320896 -0.736655,0 -1.333874,0.596418 -1.333874,1.3320896 z",
    fill: "#0f2426",
    id: "path950-4-8",
    style: {
      display: "inline",
      fill: "#203864",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.137421,
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir);
export default __webpack_public_path__ + "static/media/air.e08d03e9501cc7253f662b13d3f28e6f.svg";
export { ForwardRef as ReactComponent };